export const apiMapping = {
    0: '/api/getRejectionMonthWiseFromDailyProductionReportForDashboard',
    1: '/api/getProductionMonthWiseFromDailyProductionReportForDashboard',
    2: '/api/getMonthlyStatusDataForIRMRegisterForDashboard',
    3: '/api/getInstrumentCalibrationDataForDashboard',
    4: '/api/getCustomerComplaintTrackerMonthWiseDataForDashboard',
    5: '/api/getPreventiveChecklistDataForDashboard'
    //5: '/api/fourMChangeDashboardGraphRoute/changesForGraph/material',
    //6: '/api/fourMChangeDashboardGraphRoute/changesForGraph/method',
    //12: '/api/pendingReportsRoute/pending-reports-for-graph',
  };